import React from "react";
import * as S from "./ComingSoon.styled";

interface Props {
  icon: string;
  title: string;
  features: string[];
}

const ComingSoon: React.FC<Props> = ({ icon, title, features }) => {
  return (
    <S.Wrap>
      <S.IconWrap>{icon}</S.IconWrap>

      <S.Badge>
        <S.BadgeDot />
        개발 예정
      </S.Badge>

      <S.Title>{title}</S.Title>
      <S.Desc>
        이 페이지는 현재 개발 중입니다.<br />
        빠른 시일 내에 완성될 예정입니다.
      </S.Desc>

      <S.FeatureBox>
        <S.FeatureBoxTitle>예정 기능</S.FeatureBoxTitle>
        <S.FeatureList>
          {features.map((f) => (
            <S.FeatureItem key={f}>
              <S.FeatureDot />
              {f}
            </S.FeatureItem>
          ))}
        </S.FeatureList>
      </S.FeatureBox>
    </S.Wrap>
  );
};

export default ComingSoon;
